/**
 * "03/10/2026 às 09:00", a partir de data e hora **sem fuso** da API (`2026-10-03T09:00:00`).
 *
 * Lê o texto em vez de passar por `Date`: o valor é o horário local da paróquia, e converter
 * pelo fuso do navegador mudaria a hora para quem abre a tela de outro fuso.
 */
export function formatarDataHoraLocal(dataHora?: string | null): string {
  if (!dataHora) return '—';
  const [data, hora] = dataHora.split('T');
  const [ano, mes, dia] = (data ?? '').split('-');
  if (!ano || !mes || !dia) return dataHora;
  const hm = (hora ?? '').slice(0, 5);
  return hm ? `${dia}/${mes}/${ano} às ${hm}` : `${dia}/${mes}/${ano}`;
}
